import { useMutation } from 'react-query';
import { FairMarketValueConfigurationService } from '../../services/wealthlane-award-services';
import { CommaFormattedDecimal, CommaFormattedFloatPost } from '../../utils/global';
import { ACCEPT_DECIMAL } from '../../utils/apiDecimalConfig';
import { isEmpty } from 'lodash';

const useGetFMVconfigMarketPrice = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardType: string
): any => {
  return useMutation(
    async (payload: any) => {
      if (payload?.date) {
        return await handleRequest(
          FairMarketValueConfigurationService.getApiAwardApiAppFairMarketValueConfigurationMarketPrice(
            awardType,
            isEmpty(payload?.date) ? '' : payload?.date
          )
        );
      }
    },
    {
      onSuccess: (response: any, context: any) => {
        // If fmv is null, do not reset the user-entered FMV value
        if (response?.fmv == null) {
          return;
        }
        const calculatedGrantPrice = response?.fmv * context?.issuedUnits.replaceAll(',', '');
        const roundedGrantPrice = Number(calculatedGrantPrice.toFixed(ACCEPT_DECIMAL));
        // Format Grant Price to string with 4 decimals and comma separators
        const formattedGrantPrice = roundedGrantPrice.toFixed(ACCEPT_DECIMAL);
        const [intPart, decPart] = formattedGrantPrice.split('.');
        const formattedGrantPriceWithCommas = `${Number(intPart).toLocaleString()}.${decPart}`;
        const formattedFmv = CommaFormattedDecimal(response?.fmv);
        context?.setFieldValue(`employee.${context?.index}.marketValueAtGrant`, formattedFmv);
        context?.setFieldValue(
          `employee.${context?.index}.grantPrice`,
          formattedGrantPriceWithCommas
        );
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetFMVconfigMarketPrice;
